import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fullWidth", "fluidLayout", "sx"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { forwardRef } from 'react';
import Box from '../Box';
var Container = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var deprecatedFullwidth = _ref.fullWidth,
      fluidLayout = _ref.fluidLayout,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: deprecatedFullwidth || fluidLayout ? 'container-fluid' : 'container',
    sx: _objectSpread({
      px: function px(t) {
        return typeof t.grid !== 'undefined' && t.grid.gutters != null ? t.grid.gutters : 2;
      },
      width: '100%'
    }, sx)
  }, rest));
});
Container.displayName = 'Container';
export default Container;